import { Badge } from '@/components';
import { TaskStatus } from '../enums';

interface Colors {
  bg: string;
  text: string;
}

export const TaskStatusColors: Record<TaskStatus, Colors> = {
  [TaskStatus.ACTIVE]: { bg: '#C8E6C9', text: '#2E7D32' },
  [TaskStatus.INACTIVE]: { bg: '#BBDEFB', text: '#0D47A1' },
  [TaskStatus.DISCARDED]: { bg: '#E0E0E0', text: '#424242' },
};

const taskStatusTranslation = {
  [TaskStatus.ACTIVE]: 'ACTIVO',
  [TaskStatus.INACTIVE]: 'INACTIVO',
  [TaskStatus.DISCARDED]: 'DESCARTADO',
};

const getColorProps = (colors: any, value: string) => ({
  textColor: colors[value].text,
  backgroundColor: colors[value].bg,
  ballColor: colors[value].text,
});

export const renderStatus = (value: string) => {
  if (!value) return <></>;
  const { ...props } = getColorProps(TaskStatusColors, value);
  return (
    <Badge {...props} value={taskStatusTranslation[value as TaskStatus]} />
  );
};
